import { EditorState, ContentBlock, ContentState, CharacterMetadata, genKey, SelectionState } from 'draft-js'
import { Map, List } from 'immutable'
import { TaskState } from '@src/editor-helpers'
import addTask from './addTask'
import getTextFromState from './getTextFromState'
import getFocusKeyOfFirstConspect from './getFocusKeyOfFirstConspect'
import addTypeToNewBlock from './addTypeToNewBlock'
export default class EditorStateOps {
  static getNewState = () => {
    let editorState = EditorState.createEmpty()
    editorState = EditorState.set(editorState, { allowUndo: false })
    const contentState = editorState.getCurrentContent()
    const block = contentState.getFirstBlock()

    const newBlock = block.merge({
      data: Map({ type: 'conspect' })
    }) as ContentBlock

    const newContentState = contentState.merge({
      blockMap: contentState.getBlockMap().set(block.getKey(), newBlock)
    }) as ContentState

    editorState = EditorState.push(editorState, newContentState, 'change-block-data')
    editorState = EditorStateOps.addBlock(editorState, EditorStateOps.createContentBlock('', 'solution'))
    editorState = EditorStateOps.addBlock(editorState, EditorStateOps.createContentBlock('', 'decision'))
    editorState = EditorState.set(editorState, { allowUndo: true })
    return editorState
  }

  static addBlock = (state: EditorState, block: ContentBlock) => {
    const contentState = state.getCurrentContent()
    const newBlockMap = contentState.getBlockMap().set(block.get('key'), block)
    const newState = EditorState.push(state, ContentState.createFromBlockArray(newBlockMap.toArray()), 'split-block')
    return newState
  }
  static createContentBlock = (text = '', type = 'conspect', key = genKey()) => {
    switch (type) {
      case 'conspect':
        return new ContentBlock({
          key,
          type: 'unstyled',
          data: Map({ type: 'conspect' }),
          text,
          characterList: List(Array.from(text).map(_ => CharacterMetadata.create()))
        })

      case 'solution':
        return new ContentBlock({
          key,
          type: 'unstyled',
          data: Map({ type: 'solution' }),
          text,
          characterList: List(Array.from(text).map(_ => CharacterMetadata.create()))
        })

      case 'decision':
        return new ContentBlock({
          key,
          type: 'decision',
          data: Map({ type: 'decision' }),
          text,
          characterList: List(Array.from(text).map(_ => CharacterMetadata.create()))
        })

      default:
        throw new Error('Coudnt create conspect block')
    }
  }

  static insertBlock = (editorState: EditorState, newBlock: ContentBlock, afterBlock: ContentBlock) => {
    const contentState = editorState.getCurrentContent()
    const blockMap = contentState.getBlockMap()
    const blocksBefore = blockMap
      .toSeq()
      .takeUntil(v => v === afterBlock)
      .toArray()

    const blocksAfter = blockMap
      .toSeq()
      .skipUntil(v => v === afterBlock)
      .rest()
      .toArray()

    const newBlocks = [afterBlock, newBlock]
    const newContentState = ContentState.createFromBlockArray([...blocksBefore, ...newBlocks, ...blocksAfter])
    const newSelection = SelectionState.createEmpty(newBlock.getKey())
    let newEditorState = EditorState.push(editorState, newContentState, 'split-block')
    newEditorState = EditorState.forceSelection(newEditorState, newSelection)
    return newEditorState
  }

  static removeBlock = (editorState: EditorState, key: string) => {
    const contentState = editorState.getCurrentContent()
    let blockMap = contentState.getBlockMap()
    blockMap = blockMap.toSeq().filter(v => v != null && v.get('key') !== key) as ContentBlock
    const newContentState = ContentState.createFromBlockArray(blockMap.toArray()) as ContentState
    let newEditorState = EditorState.push(editorState, newContentState, 'split-block')
    return newEditorState
  }

  static checkSolutionPresent = (editorState: EditorState) => {
    const taskState = TaskState.fromEditorState(editorState)
    const tasksWithoutSolution = TaskState.getTasksWithoutSolution(taskState)
    if (tasksWithoutSolution.length > 0) {
      tasksWithoutSolution.forEach(task => {
        const content = editorState.getCurrentContent()
        const lastConspectKey = TaskState.getLastConspectKey(task)
        const lastConspectBlock = content.getBlockForKey(lastConspectKey)
        editorState = EditorStateOps.insertBlock(
          editorState,
          EditorStateOps.createContentBlock('', 'decision'),
          lastConspectBlock
        )
      })
    }
    return editorState
  }

  static checkTasksWithoutSolution = (editorState: EditorState) => {
    const taskState = TaskState.fromEditorState(editorState)
    const tasksWithoutDecision = TaskState.getTasksWithoutDecision(taskState)
    if (tasksWithoutDecision.length > 0) {
      editorState = EditorState.set(editorState, { allowUndo: false })
      const contentState = editorState.getCurrentContent()
      const selection = editorState.getSelection()
      tasksWithoutDecision.forEach(task => {
        const lastConspectBlockKey = TaskState.getLastConspectKey(task)
        const lastConspectBlock = contentState.getBlockForKey(lastConspectBlockKey)
        const decisionBlock = EditorStateOps.createContentBlock('', 'solution')
        editorState = EditorStateOps.insertBlock(editorState, decisionBlock, lastConspectBlock)
        editorState = EditorState.forceSelection(editorState, selection)
      })
      editorState = EditorState.set(editorState, { allowUndo: false })
    }
    return editorState
  }

  static getFocusBlock = (editorState: EditorState) => {
    let selection = editorState.getSelection()
    const blockKey = selection.get('focusKey')
    const content = editorState.getCurrentContent()
    const block = content.getBlockForKey(blockKey)
    return block
  }

  static addTask = addTask
  static getTextFromState = getTextFromState
  static getFocusKeyOfFirstConspect = getFocusKeyOfFirstConspect
  static addTypeToNewBlock = addTypeToNewBlock
}



// WEBPACK FOOTER //
// ./src/editor-helpers/EditorStateOps/EditorStateOps.ts